import { render, staticRenderFns } from "./activechannel.vue?vue&type=template&id=64009461"
import script from "./activechannel.vue?vue&type=script&lang=js"
export * from "./activechannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports